import Card from "./Card.js";
import photography from "../../../data/work/photography.js";
function PhotographyPdf() {
  return (
    <>
      <div className="row">
        {photography.map((item, key) => {
          return (
            <div key={key} className="col-lg-4 col-md-6">
              <Card pic={item.tb} pdf={item.pdf} />
            </div>
          );
        })}
      </div>
    </>
  );
}

export default PhotographyPdf;
